import { useEffect, useState } from "react";
import { CheckCircle2, ChevronDown, Circle } from "lucide-react";

// Collapsible job-form section. Children stay mounted (hidden) so auto-extract effects keep running.
export default function FormSection({ id, title, summary, done, missing, defaultOpen = false, forceOpen = 0, children }) {
  const [open, setOpen] = useState(defaultOpen);
  useEffect(() => { if (forceOpen) setOpen(true); }, [forceOpen]);
  const jump = () => {
    setOpen(true);
    setTimeout(() => {
      const el = missing && document.querySelector(`[data-testid="${missing}"]`);
      if (!el) return;
      el.scrollIntoView({ block: "center", behavior: "smooth" });
      const target = el.matches("input,textarea,select,button") ? el : el.querySelector("input,textarea,select,button");
      target?.focus({ preventScroll: true });
      el.classList.add("rs-flash");
      setTimeout(() => el.classList.remove("rs-flash"), 1600);
    }, 60);
  };
  return (
    <section className="rounded-xl border border-[color:var(--bd-sub)]" data-testid={`section-${id}`}>
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid={`section-${id}-toggle`}
        className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-[color:var(--bg-elev)] rounded-xl transition-colors">
        {done === undefined ? null : done
          ? <CheckCircle2 className="w-4 h-4 shrink-0 text-emerald-500" data-testid={`section-${id}-done`} aria-label="Complete" />
          : <span role="button" tabIndex={0} title="Jump to the missing field" data-testid={`section-${id}-todo`} aria-label="Incomplete — jump to missing field"
              onClick={(e) => { e.stopPropagation(); jump(); }} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); e.stopPropagation(); jump(); } }}
              className="shrink-0 rounded-full hover:text-amber-500 text-slate-300 transition-colors"><Circle className="w-4 h-4" /></span>}
        <span className="font-display font-semibold text-sm">{title}</span>
        {!open && summary && <span className="text-xs text-slate-500 truncate min-w-0" data-testid={`section-${id}-summary`}>{summary}</span>}
        <ChevronDown className={`w-4 h-4 ml-auto shrink-0 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={open ? "grid gap-3 px-4 pb-4" : "hidden"}>{children}</div>
    </section>
  );
}
